import React, { useEffect, useState } from 'react';
import { AuthProvider } from 'react-oauth2-code-pkce';
import { getOauthConfig, type OauthConfig } from './services/oauth';
import { rememberPostAuthRedirect } from 'utils/postAuthRedirect';

const OAuth2Provider = ({ children }: { children: React.ReactNode }) => {
  const [oauthConfig, setOauthConfig] = useState<OauthConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const config = await getOauthConfig();
        setOauthConfig(config ?? null);
      } catch (error) {
        console.error('Failed to load OAuth config:', error);
      } finally {
        setLoading(false);
      }
    };
    loadConfig();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!oauthConfig) {
    return <>{children}</>;
  }

  return (
    <AuthProvider
      authConfig={{
        clientId: oauthConfig.clientId,
        authorizationEndpoint: oauthConfig.authorizationEndpoint,
        tokenEndpoint: oauthConfig.tokenEndpoint,
        redirectUri: oauthConfig.redirectUri,
        scope: 'openid profile email User.Read',
        autoLogin: false,
        preLogin: () => {
          rememberPostAuthRedirect();
        },
      }}
    >
      {children}
    </AuthProvider>
  );
};

export default OAuth2Provider;
